/* eslint-disable i18next/no-literal-string -- legal text: must render in English regardless of form language */
const DEFAULT_COMPANY_NAME = "Tellescope";

export interface ESignatureTermsPageProps {
  companyName?: string;
}

export const ESignatureTermsPage = ({ companyName }: ESignatureTermsPageProps) => {
  const name = companyName?.trim() ? companyName : DEFAULT_COMPANY_NAME;

  return (
    <main className="mx-auto max-w-2xl px-6 py-12 sm:py-16">
      <h1 className="text-3xl font-semibold tracking-tight text-balance">{name} Electronic Signature Terms</h1>
      <hr className="border-border my-6" />
      <p className="text-muted-foreground text-[15px] leading-7 text-pretty">
        By selecting the &quot;I consent to use electronic signatures&quot; checkbox, you are signing this Agreement
        electronically. You agree your electronic signature is the legal equivalent of your manual/handwritten signature
        on this Agreement. By selecting &quot;I consent to use electronic signatures&quot; using any device, means or
        action, you consent to the legally binding terms and conditions of this Agreement. You further agree that your
        signature on this document (hereafter referred to as your &quot;E-Signature&quot;) is as valid as if you signed
        the document in writing. You also agree that no certification authority or other third party verification is
        necessary to validate your E-Signature, and that the lack of such certification or third party verification will
        not in any way affect the enforceability of your E-Signature or any resulting agreement between you and {name}{" "}
        or between you and a customer of {name}.
      </p>
    </main>
  );
};
